import React, { useEffect, useState } from 'react'
import styled from 'styled-components'

import { assetPrefix } from 'config/env_config'

const Label = styled.label`
  display: block;
  font-size: 1rem;
  opacity: 0.7;
  font-size: ${props => props.subtitle ? '1rem' : '1.3rem'};
  line-height: 1.3rem;
  position: relative;
  opacity: .7;
  transition: all ease .1s;

  ${props => props.mobile && `
    position: absolute;
    top: 8px;
    left: 12px;
    font-family: var(--primary-font);
    z-index: 1;
  `}
`

const NativeSelectContainer = styled.div`
  position: relative;
`

const NativeSelect = styled.select`
  width: 100%;
  background-color: var(--the-white);
  position: relative;
  border: 2px solid var(--alto-gray);
  padding: ${props => props.value ? '1.5rem 3.5rem .6rem 1rem' : '.6rem 1rem'};
  border-radius: 5px;
  cursor: pointer;
  min-width: 5rem;
  min-height: 45px;
  appearance: none;
  font-size: 16px;
  font-family: var(--primary-font);
  font-weight: 600;

  &[disabled] {
    background-color: var(--alto-gray);
    cursor: not-allowed;
  }

  &:focus {
    outline: unset;
  }

  ${props => props.value === '' && `
    color: var(--gray-3);
    opacity: 0.7;
  `}
`

const SelectArrow = styled.svg`
  position: absolute;
  fill: var(--cobasi-blue);
  position: absolute;
  top: 50%;
  width: 3rem;
  height: 3rem;
  right: 1rem;
  transform: ${props => props.active ? 'translateY(-50%) rotate(180deg)' : 'translateY(-50%) rotate(0deg)'};
  transition: transform ease .2s;
  cursor: pointer;
  pointer-events: none;

  &[disabled] {
    opacity: .5;
  }
`

const Select = ({ options = [], label = 'Escolha uma opção', onChange, selectedValue: initialValue, id = '', disabled = false, dataTest }) => {
  const [active, setActive] = useState(false)
  const [selectedValue, setSelectedValue] = useState('')

  useEffect(() => {
    if (initialValue) {
      setSelectedValue(initialValue)
    }
  }, [initialValue])

  const handleSelectOption = event => {
    const { value } = event.target

    setSelectedValue(value)
    if (onChange) {
      onChange(value)
      setActive(false)
    }
  }

  const handleSelectOpen = () => {
    setActive(true)
  }

  const handleSelectClose = () => {
    setActive(false)
  }

  return (
    <NativeSelectContainer>
      {selectedValue !== undefined && selectedValue !== '' && <Label mobile subtitle>{label}</Label>}
      <NativeSelect id={id} value={selectedValue} onChange={handleSelectOption} onFocus={handleSelectOpen} onBlur={handleSelectClose} disabled={disabled} data-test={dataTest}>
        <option value=''>{label}</option>
        {options.map((option, i) => (<option key={i} value={option.value}>{option.name}</option>))}
      </NativeSelect>
      <SelectArrow active={active} disabled={disabled}>
        <use xlinkHref={`${assetPrefix}/static/icons.svg#icon-keyboard_arrow_down`} />
      </SelectArrow>
    </NativeSelectContainer>
  )
}

export default Select
